<template>
  <v-form ref="form">
    <v-card flat style="position: relative">
      <div style="position: absolute; right: 0px; z-index: 10">
        <v-btn @click="close" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-text class="clearfix">
        <div ref="top-right" :class="rightColumnClass">
          <v-card flat class="pa-4">
            <v-layout align-center class="green--text mb-4">
              <h3>{{ title }}</h3>
            </v-layout>
            <v-select
              clearable
              :label="$t('common.Type')"
              :items="logtypes || []"
              item-value="id"
              item-text="label"
              v-model="logEntry.logbook"
              :disabled="disabled"
              solo
              class="thin-border"
            />
            <template v-for="component in components">
              <AirField
                v-if="component.id === 'status'"
                :key="component.id"
                v-model="logEntry[component.id]"
                :component="component"
              />
            </template>
            <v-checkbox v-model="logEntry.incompleted" label="Incompleto" />
          </v-card>
        </div>

        <div v-if="logEntry.logbook" class="left-column">
          <v-card flat class="pa-4">
            <v-layout align-center class="green--text mb-4">
              <Icon name="heart" class="mr-2" />
              <h2>{{ logbookLabel }}</h2>
            </v-layout>
            <v-layout wrap justify-space-between>
              <template v-for="component in components">
                <v-flex
                  v-if="
                    component.type !== 'subcomponent' &&
                    !rightColumn.includes(component.id)
                  "
                  :key="component.id"
                  class="px-2"
                  v-bind="
                    component.id === 'title' ? { md12: true } : size(component)
                  "
                >
                  <AirField
                    v-if="component.type !== 'custom'"
                    :key="component.id"
                    v-model="logEntry[component.id]"
                    :component="component"
                  />
                  <file-upload
                    :file-url-uploaded.sync="logEntry['fileUrlAttached']"
                    :file-name-uploaded.sync="logEntry['fileNameAttached']"
                    @fileRemoved="fileRemoved"
                    @uploadComplete="fileAdded"
                    v-else-if="component.id === 'attach-file'"
                    :path-to-files="filepath"
                  />
                  <JournalField
                    v-else-if="
                      component.id === 'journal-detail' &&
                      logEntry['publication-type'] === 'paper'
                    "
                    :logEntry="logEntry"
                  />
                  <BookField
                    v-else-if="
                      component.id === 'book-detail' &&
                      logEntry['publication-type'] === 'book'
                    "
                    :logEntry="logEntry"
                  />
                  <Authors
                    v-else-if="component.id === 'authors'"
                    v-model="logEntry['authors']"
                    :authorship.sync="logEntry['authorship']"
                  />
                </v-flex>
              </template>
            </v-layout>
          </v-card>
        </div>
      </v-card-text>
      <v-card-text>
        <div class="pl-2">
          <v-btn
            v-if="updateMode"
            color="secondary"
            :disabled="!logEntry.logbook"
            :loading="loading"
            depressed
            round
            @click="submit"
            >{{ $t(this.logToEdit ? 'common.Update' : 'common.Submit') }}</v-btn
          >
          <v-btn
            v-if="updateMode"
            color="error"
            round
            depressed
            @click="close"
            >{{ $t('common.Cancel') }}</v-btn
          >
          <v-btn
            v-if="!updateMode"
            color="error"
            round
            depressed
            @click="close"
          >
            {{ $t('common.Close') }}
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-form>
</template>
<script>
import { SubComponent } from '@/models/ScientificActivity'

import AirField from './AirField'
import JournalField from './Journal'
import Authors from './Authors'
import BookField from './Book'
import FileUpload from '@/components/files/FileUpload'

export default {
  components: {
    AirField,
    JournalField,
    BookField,
    Authors,
    FileUpload
  },
  props: {
    title: { type: String, required: true },
    logToEdit: { type: Object, default: null },
    close: { type: Function, required: true },
    logtypes: { default: null },
    allcomponents: { default: null },
    submitHandler: { type: Function },
    updateMode: { type: Boolean, default: true }
  },
  data() {
    return {
      disabled: false,
      logEntry: {
        userId: this.$store.getters.profile.id,
        incompleted: null
      },
      loading: false,
      rightColumn: ['status']
    }
  },
  created() {
    this.disabled = this.logToEdit ? true : false
    this.makeLogEntry()
  },
  computed: {
    filepath() {
      return `${this.$store.getters.profile.id}/${this.logEntry.logbook || ''}`
    },
    logbookLabel() {
      return this.logtypes
        ? this.logtypes.find(logtype => logtype.id === this.logEntry.logbook)
            .label || ''
        : ''
    },
    components() {
      let components = this.allcomponents.filter(component =>
        component.logbooks.includes(this.logEntry.logbook)
      )

      // // moving the title to a better location in the form
      // const tIndex = components.findIndex(Component => {
      //   console.log(Component.id === 'title')
      //   return Component.id === 'title'
      //   })
      // const title = components[tIndex]
      // components.splice(tIndex, 1)
      // components.splice(2, 0, title)
      return components
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    rightColumnClass() {
      const mainClass = this.logEntry.logbook ? 'right-column' : ''
      if (!this.isMobile) {
        return [mainClass, 'sticky']
      }
      return [mainClass]
    }
  },
  methods: {
    makeLogEntry() {
      this.logEntry = this.logToEdit
        ? { ...this.logToEdit, userId: this.$store.getters.profile.id }
        : { userId: this.$store.getters.profile.id }
    },
    submit() {
      this.loading = true

      this.submitHandler(this.logEntry)
        .then(() => {
          this.loading = false
          this.close()
          this.$refs.form.reset()
        })
        .catch(err =>
          this.showErrorSnackbar(err.message || 'Something went wrong')
        )
        .finally(() => {
          if (!this.logEntry) {
            this.logEntry = {
              userId: this.$store.getters.profile.id,
              logbook: null
            }
          }
        })
    },
    changePublicationType(newtype) {
      const clearableIds = SubComponent.query()
        .where(el => ['journal', 'book'].indexOf(el.owner) >= 0)
        .get()
        .map(el => el.id)
      clearableIds.forEach(id => {
        this.logEntry[id] = null
      })
      this.$set(this.logEntry, 'publication-type', newtype)
    },
    fileRemoved() {
      this.logEntry['fileUrlAttached'] = ''
      this.logEntry['fileNameAttached'] = ''
    },
    fileAdded(fileUrl, fileName) {
      this.logEntry['fileUrlAttached'] = fileUrl
      this.logEntry['fileNameAttached'] = fileName
    },
    size(component) {
      let size = {
        xs: 'md2',
        sm: 'md3',
        md: 'md6',
        lg: 'md8',
        xl: 'md10',
        xxl: 'md12'
      }[component.size]

      let sizeMobile = {
        xs: 'xs2',
        sm: 'xs3',
        md: 'xs5',
        lg: 'xs8',
        xl: 'xs10',
        xxl: 'xs12'
      }[component.sizeMobile]

      if (!size) {
        size = [
          'single-select-tree',
          'multi-select-tree',
          'custom',
          'icdo-topography',
          'icdo-histology',
          'icd10',
          'icd10-sec',
          'autonomy'
        ].includes(component.type)
          ? 'md12'
          : 'md6'
      }

      if (!sizeMobile) {
        sizeMobile = 'xs12'
      }
      return { [size]: true, [sizeMobile]: true }
    }
  },
  watch: {
    'logEntry.logbook'(val) {
      if (val) {
        this.$emit('update:expandDialog', true)
      } else {
        this.$emit('update:expandDialog', false)
      }
    },
    logToEdit() {
      this.disabled = this.logToEdit ? true : false
      this.makeLogEntry()
    }
  }
}
</script>
